// api.js
import axios from 'axios';


/**
 * auth token is a base64 encoded string of the username and sid
 * **/
export function apiWithToken(authToken){
    return axios.create({
        baseURL: 'https://rest.zoiehealth.com/api',
        headers:{
            'ZH-API-Key': '9e68863eaaaab20c2219cbd2630e287e8efd4f137382cfb34ae7bd067e6ae662',
            'Authorization': 'Basic ' + authToken,
            'Content-Type': 'application/json'
    }});
}
export function apiWithNoAuth(){
    return axios.create({
        baseURL: 'https://rest.zoiehealth.com/api',
        headers:{
            'ZH-API-Key': '9e68863eaaaab20c2219cbd2630e287e8efd4f137382cfb34ae7bd067e6ae662',
            'Authorization': 'Basic dXNlckB6b2llaGVhbHRoLmNvbTpCb29raW5ncw==',
            'Content-Type': 'application/json'
    }});
}

export function apiTwilio(){
  return axios.create({
    baseURL: 'https://api-427131572880.africa-south1.run.app/api/twilio',
    headers:{
      'Content-Type': 'application/json',
      'X-EasyDoc-App' : 'admin'
    }
  });
}


